import { render, staticRenderFns } from "./sss_zhuanlan.vue?vue&type=template&id=e90dfad8&scoped=true"
import script from "./sss_zhuanlan.vue?vue&type=script&lang=js"
export * from "./sss_zhuanlan.vue?vue&type=script&lang=js"
import style0 from "./sss_zhuanlan.vue?vue&type=style&index=0&id=e90dfad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90dfad8",
  null
  
)

export default component.exports